"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReservationSummaryTextBlock = void 0;
const react_1 = __importDefault(require("react"));
const __1 = require("..");
const ReservationSummaryTextBlock = (props) => {
    const { id, title, textItems, } = props;
    if (!textItems)
        return null;
    return (react_1.default.createElement("div", { className: `${__1.className}__block` },
        react_1.default.createElement("h4", { className: `${__1.className}__subtitle` }, title),
        react_1.default.createElement("div", { className: `${__1.className}__block-content` }, textItems.map((textItem, index) => (react_1.default.createElement("p", { key: `rs-textItem::${id}:${index}` }, textItem))))));
};
exports.ReservationSummaryTextBlock = ReservationSummaryTextBlock;
//# sourceMappingURL=index.js.map